import React from "react";

const PopupContext = React.createContext(null);

export default PopupContext;
